import React from "react";
import { FormattedMessage, injectIntl, Link } from "gatsby-plugin-intl";
import {
  Icon,
  Grid,
  Segment,
  Header,
  Button,
  Statistic,
  Label,
} from "semantic-ui-react";
import { PICPICK_DISCOUNT } from "../constants";
import HardLink from "./HardLink";

const TableFreeBuy = ({ intl }) => (
  <Grid columns="2" centered divided padded stackable verticalAlign="middle">
    <Grid.Column width={7}>
      <Segment.Group>
        <Segment secondary textAlign="center">
          <Header color="grey" as="h4" icon style={{ marginBottom: 0 }}>
            <Icon name="home" />
            <FormattedMessage id="download_1_h1" />
          </Header>
        </Segment>
        <Segment
          padded
          textAlign="center"
          className="flex-center"
          style={PICPICK_DISCOUNT ? { height: 130 } : { height: 100 }}
        >
          <Statistic
            color="green"
            size="medium"
            horizontal
            value={intl.formatMessage({ id: "text_free" })}
          />
        </Segment>
        <Segment>
          <FormattedMessage id="download_1_p1" />
          <Icon
            name="exclamation circle"
            color="red"
            style={{ float: "right" }}
          />
        </Segment>
        <Segment>
          <FormattedMessage id="download_1_p2" />
          <Icon
            name="exclamation circle"
            color="red"
            style={{ float: "right" }}
          />
        </Segment>
        <Segment>
          <FormattedMessage id="download_1_p3" />
          <Icon
            name="exclamation circle"
            color="red"
            style={{ float: "right" }}
          />
        </Segment>
        <Segment>&nbsp;</Segment>
        <Segment>
          <Button
            size="huge"
            color="blue"
            fluid
            content={intl.formatMessage({ id: "nav_download" })}
            as={Link}
            name="download_start"
            to="/download/free"
          />
        </Segment>
        <Segment>
          <Button
            size="big"
            fluid
            content={intl.formatMessage({
              id: "button_download_portable",
            })}
            as={Link}
            name="download_start"
            to="/download/portable"
          />
        </Segment>
      </Segment.Group>
    </Grid.Column>
    <Grid.Column width={7}>
      <Segment.Group raised>
        <Segment secondary textAlign="center">
          <Header
            color="grey"
            as="h4"
            icon
            style={{ marginBottom: 0, marginTop: 0 }}
          >
            <Icon name="briefcase" />
            <FormattedMessage id="download_2_h1" />
          </Header>
        </Segment>
        <Segment
          padded
          textAlign="center"
          className={PICPICK_DISCOUNT ? "" : "flex-center"}
          style={PICPICK_DISCOUNT ? { height: 130 } : { height: 100 }}
        >
          <Statistic
            style={{ margin: 0 }}
            className={PICPICK_DISCOUNT ? "strike" : "no-strike"}
            size="medium"
            color="blue"
            horizontal
            value="$30"
          />
          {PICPICK_DISCOUNT && (
            <>
              <Statistic
                style={{ marginBottom: "1em" }}
                size="medium"
                color="red"
                value="$24"
                horizontal
              />
              <p>
                <Label color="red">
                  {intl.formatMessage({ id: "text_limitedtimeoffer" })}
                </Label>
              </p>
            </>
          )}
        </Segment>
        <Segment>
          <FormattedMessage id="download_2_p1" />
          <Icon name="check circle" color="green" style={{ float: "right" }} />
        </Segment>
        <Segment>
          <FormattedMessage id="download_2_p2" />
          <Icon name="check circle" color="green" style={{ float: "right" }} />
        </Segment>
        <Segment>
          <FormattedMessage id="download_2_p3" />
          <Icon name="check circle" color="green" style={{ float: "right" }} />
        </Segment>
        <Segment>
          <FormattedMessage id="download_2_p5" />
          <Icon name="check circle" color="green" style={{ float: "right" }} />
        </Segment>
        <Segment>
          <Button
            size="huge"
            color="orange"
            fluid
            content={intl.formatMessage({ id: "nav_buy" })}
            as={HardLink}
            name="buy"
            to="/buy"
          />
        </Segment>
        <Segment>
          <Button
            size="big"
            fluid
            content={intl.formatMessage({
              id: "button_download_commercial",
            })}
            as={Link}
            name="download_start"
            to="/download/pro"
          />
        </Segment>
      </Segment.Group>
    </Grid.Column>
  </Grid>
);

export default injectIntl(TableFreeBuy);
